import { ref } from 'vue';
import { copyToClipboard } from '@/utils/apostatudo/clipboard';
import { shareNative } from '~/shared/NativeBridge';

/**
 * Link de indicação (Indique e Ganhe), compartilhado entre a página antiga
 * (pages/user/refers.vue) e a tela nova do Minha Conta V2
 * (components/user-v2/ScreenRefers.vue).
 */
export function useReferralLink() {
  const { t } = useTexts();
  const layout = useLayoutStore();
  const { userAffiliationCode } = useUserData();

  const isLinkCopied = ref(false);

  const affiliationLink = computed(() => {
    if (!userAffiliationCode.value) return '';

    return `https://${location.hostname}?ref=${userAffiliationCode.value}`;
  });

  async function copyLink() {
    if (!affiliationLink.value) return;

    const ok = await copyToClipboard(affiliationLink.value);

    if (ok) {
      isLinkCopied.value = true;
      setTimeout(() => {
        isLinkCopied.value = false;
      }, 3000);
    } else {
      layout.openToaster({
        message: t('casino.game.sharing.not_supported'),
        type: 'error',
      });
    }
  }

  async function shareLink() {
    const title = `${t('account.refer_friend_come_play')} ${appName()}`;
    const url = affiliationLink.value;

    const outcome = await shareNative({ title, message: title, url });

    if (outcome === 'navigator') {
      layout.openToaster({
        message: t('casino.game.sharing.success'),
        type: 'success',
      });

      return;
    }

    if (outcome === 'native-app' || outcome === 'aborted') {
      return;
    }

    // encodeURIComponent no texto: sem ele, espaço/"&"/":" no título ou na
    // própria URL (query params) quebram o link do wa.me.
    const whatsappText = encodeURIComponent(`${title}: ${url}`);

    await navigateTo(`https://wa.me/?text=${whatsappText}`, {
      external: true,
      open: { target: '_blank' },
    });
  }

  return { affiliationLink, isLinkCopied, copyLink, shareLink };
}
